export default __webpack_public_path__ + "static/media/rate_icon.ff5c285f.svg";